var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortalLeftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 32,
    viewBox: "0 0 144 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_8812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7996 0.3125V26.4843L7.50347 31.6877H7.44208V0.3125H13.7996Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25388 10.9001L11.135 4.01562L7.43488 0.31368L0.55372 7.19815L4.25388 10.9001Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8351 15.7483L47.3279 23.5755L43.1706 18.3574L41.0784 15.7213L46.8466 8.85709L47.4801 8.09795L48.7423 6.60424L51.3894 3.4596H51.3771L54.0217 0.3125H66.663L64.0503 3.4596L61.4376 6.60424L53.8351 15.7483Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0068 31.6191H53.7295L50.3187 27.3394L47.8214 24.1948L47.7821 24.1456L54.3016 16.3086L55.2495 17.451L60.8556 24.1948H60.8236L63.4413 27.3394L67.0068 31.6191Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2856 0.3125L25.5347 6.60425H19.3614V0.3125H31.2856Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9814 0.3125L24.329 14.9744H23.4303L38.0827 0.3125H38.9814Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7721 19.1024C39.7721 26.0059 34.1783 31.6024 27.2782 31.6024C23.7593 31.6024 20.5818 30.148 18.3129 27.8067L23.1995 22.9178C24.2136 24.011 25.6648 24.6915 27.2757 24.6915C30.3624 24.6915 32.8621 22.1881 32.8621 19.1024C32.8621 18.2819 32.6853 17.5055 32.3661 16.8029C32.0616 16.1248 31.627 15.5205 31.0892 15.0193L35.9733 10.1328C37.7905 11.8968 39.0723 14.2086 39.556 16.8029C39.696 17.5473 39.7672 18.3163 39.7672 19.1024H39.7721Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0709 2.85799C33.7002 2.85799 34.2103 2.34763 34.2103 1.71806C34.2103 1.08849 33.7002 0.578125 33.0709 0.578125C32.4416 0.578125 31.9315 1.08849 31.9315 1.71806C31.9315 2.34763 32.4416 2.85799 33.0709 2.85799Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.943 14.9752C29.5723 14.9752 30.0824 14.4648 30.0824 13.8352C30.0824 13.2057 29.5723 12.6953 28.943 12.6953C28.3138 12.6953 27.8036 13.2057 27.8036 13.8352C27.8036 14.4648 28.3138 14.9752 28.943 14.9752Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4069 4.25V27.75",
    stroke: "#2D2F51",
    strokeWidth: 0.203336,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7879 10.4688H84.0141V21.3313H82.6338V11.9834V11.9159L82.5689 11.9345L80.213 12.6121L79.8695 11.4548L82.7879 10.4688Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9915 14.8811L92.032 14.917L92.024 14.9607C93.6359 15.2555 94.9143 16.3508 94.9143 18.1383C94.9143 19.2352 94.4623 20.0824 93.761 20.6563C93.0585 21.2311 92.1033 21.5337 91.0967 21.5337C89.4658 21.5337 88.0328 20.8015 87.4529 19.3821L88.6184 18.7168C88.7956 19.2071 89.1017 19.5765 89.5132 19.825C89.9401 20.0829 90.4775 20.209 91.0967 20.209C91.7814 20.209 92.3855 20.0306 92.8196 19.6808C93.255 19.33 93.5149 18.8101 93.5149 18.1383C93.5149 17.4666 93.2551 16.9425 92.8199 16.5874C92.3859 16.2332 91.7817 16.0503 91.0967 16.0503H90.738L90.1767 15.2117L92.766 11.8081L92.8281 11.7265H92.7256H87.7607V10.4688H94.4314V11.6844L91.9915 14.8811Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.405 17.2564L105.833 20.9836H103.989L100.853 17.549L100.764 17.4522V17.5833V20.9836H99.2051V10.6251H100.764V16.8657V16.9979L100.853 16.8998L103.821 13.6131H105.71L102.407 17.1888L102.442 17.2211L102.405 17.2564Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.704 14.6237V13.6131H116.26V20.9835H114.704V19.9556V19.8014L114.613 19.9253C114.035 20.706 113.143 21.1759 111.96 21.1759C109.896 21.1759 108.18 19.496 108.18 17.2989C108.18 15.1019 109.896 13.4219 111.96 13.4219C113.143 13.4219 114.036 13.892 114.613 14.6544L114.704 14.775V14.6237ZM109.743 17.2989C109.743 18.7185 110.808 19.7395 112.221 19.7395C113.634 19.7395 114.704 18.7186 114.704 17.2989C114.704 15.8792 113.634 14.8584 112.221 14.8584C110.808 14.8584 109.743 15.8794 109.743 17.2989Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.963 14.8174L122.06 14.8383C122.5 13.8631 123.393 13.4899 124.33 13.477V15.1197C123.791 15.0917 123.211 15.201 122.758 15.522C122.288 15.8557 121.963 16.4135 121.963 17.2642V20.9811H120.404V13.6107H121.963V14.8174Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.504 14.6237V13.6131H135.063V20.9835H133.504V19.9556V19.8003L133.412 19.9255C132.84 20.7059 131.947 21.1759 130.76 21.1759C128.701 21.1759 126.984 19.496 126.984 17.2989C126.984 15.1018 128.701 13.4219 130.76 13.4219C131.947 13.4219 132.84 13.892 133.412 14.6542L133.504 14.776V14.6237ZM128.544 17.2989C128.544 18.7186 129.613 19.7395 131.026 19.7395C132.434 19.7395 133.504 18.7186 133.504 17.2989C133.504 15.8794 132.437 14.8584 131.026 14.8584C129.614 14.8584 128.544 15.8792 128.544 17.2989Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.487 13.5605V13.6114H141.538H143.395V15.064H141.538H141.487V15.1148V18.7C141.487 18.9434 141.528 19.1318 141.615 19.2748C141.703 19.419 141.834 19.5115 142.002 19.5689C142.169 19.6257 142.374 19.6487 142.614 19.6542C142.841 19.6595 143.102 19.6493 143.395 19.6359V20.9861C142.144 21.1279 141.282 21.0269 140.731 20.6644C140.179 20.3008 139.928 19.6642 139.928 18.7V15.1148V15.064H139.877H138.515V13.6101H139.877H139.928V13.5593V11.9837L141.487 11.5362V13.5605Z",
    fill: "#2D2F51",
    stroke: "#2D2F51",
    strokeWidth: 0.101668
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_8812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.892,
    height: 32,
    fill: "white",
    transform: "translate(0.553772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalLeftLogo);
export default __webpack_public_path__ + "static/media/Portal_left_logo.a8ac00d35ff34cc6e5243cf1a2ee4a76.svg";
export { ForwardRef as ReactComponent };